var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-container"},[_c('Card',[_vm._v(" 111 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }